
import Vue from 'vue';
import { TransformedLegalPage } from '~/transforms/transformPages';

export default Vue.extend({
  name: 'legalPage',
  props: {
    pageData: {
      type: Object as () => TransformedLegalPage,
      required: true,
    },
  },
  mounted() {
    setTimeout(() => {
      window.UC_UI.closeCMP();
    }, 500);
  },
  async destroyed() {
    if (await window.UC_UI.isConsentRequired()) {
      window.UC_UI.showFirstLayer();
    }
  },
});
